import React, { useEffect } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, useLocation } from "react-router-dom";
import "./global.css";
import "./index.css";
import Wrapper from "components/Wrapper/Wrapper";
import { RecoilRoot } from "recoil";
import { CookiesProvider } from "react-cookie";
import { GoogleOAuthProvider } from "@react-oauth/google";
import ModalContainer from "components/ModalContainer";
import { envUtil } from "utils";
import ScrollToTop from "components/ScrollToTop";
import { QueryClient, QueryClientProvider } from "react-query";

const queryClient = new QueryClient();

const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);

  root.render(
    <CookiesProvider>
      <RecoilRoot>
        <GoogleOAuthProvider clientId={envUtil.GOOGLE.WEB_CLIENT_ID}>
          <QueryClientProvider client={queryClient}>
            <BrowserRouter>
              <ScrollToTop />
              <Wrapper>
                <ModalContainer>
                  <App />
                </ModalContainer>
              </Wrapper>
            </BrowserRouter>
          </QueryClientProvider>
        </GoogleOAuthProvider>
      </RecoilRoot>
    </CookiesProvider>,
  );
}

reportWebVitals();
